import { FeatureDefinition } from '@growthbook/growthbook';

import { UserStore } from '../../types/store/userStore';

import * as actionTypes from './actionTypes';

export const setFeatures = (payload: FeatureDefinition) => {
    return {
        type: actionTypes.SET_FEATURES,
        payload,
    } as const;
};

export const initAbTest = (payload: UserStore) => {
    return {
        type: actionTypes.INIT_AB_TEST,
        payload,
    } as const;
};
